
// THIS IS DEPRECATED - user Fields3 Enum !
// THIS IS DEPRECATED - user Fields3 Enum !
// THIS IS DEPRECATED - user Field3 Enum !

// Field 3.0 DEPRECTATED !!!!

// THIS IS DEPRECATED - user Fields3 Enum !
// THIS IS DEPRECATED - user Fields3 Enum !
// THIS IS DEPRECATED - user Field3 Enum !

export const FIELDS = {
    STRING                          : 'string',
    TEXT                            : 'textarea',
    DROPDOWN                        : 'dropdown',
    MULTISELECT                     : 'multiselect',
    COLOR                           : 'color',
    USER                            : 'user',
    USERS                           : 'users',
    PHONE                           : 'phone',
    EMAIL                           : 'email',
    URL                             : 'url',
    CHECKBOX                        : 'checkbox',
    TOGGLE                          : 'toggle',
    NUMBER                          : 'number',
    CURRENCY                        : 'currency',
    PERCENTAGE                      : 'percentage',
    DATE                            : 'date',
    DATE_RELATIVE                   : 'date-relative',
    MOMENT                          : 'moment',
    DATE_RANGE                      : 'date-range',
    DATE_RANGE_RELATIVE             : 'date-range-relative',
    RATING                          : 'rating',
    RAG                             : 'rag',
    FORMULA                         : 'formula',
    PROJECT                         : 'project',    // i.e. parent
    PROJECTS                        : 'projects',
    TAGS                            : 'tags',

    // TASK
    TASK_ID                         : 'task-id',
    TASK_TITLE                      : 'task-title',
    TASK_TYPE                       : 'task-type',
    TASK_PROJECT                    : 'task-project',
    TASK_STATUS                     : 'task-status',
    TASK_SYSTEM_STATUS              : 'task-system-status',
    TASK_PRIORITY                   : 'task-priority',
    TASK_STORY_POINTS               : 'task-story-points',
    TASK_ACTION_REQUIRED            : 'task-action-required',
    TASK_ASSIGNED_TO                : 'task-assigned-to',
    TASK_TIME_REPORTED              : 'task-time-reported',
    TASK_ESTIMATE                   : 'task-estimate',
    TASK_PROGRESS                   : 'task-progress',
    TASK_DESCRIPTION_EDITOR         : 'task-description-editor',
    TASK_CREATED_BY                 : 'task-created',

    // PROJECT
    PROJECT_NAME                    : 'project-name',
    PROJECT_STATUS                  : 'project-status',
    PROJECT_SYSTEM_STATUS           : 'project-system-status',  // used for folders, tags ?
    PROJECT_OWNER                   : 'project-owner',
    PROJECT_START_END               : 'project-start-end',
    PROJECT_DEADLINE                : 'project-deadline',
    PROJECT_ACCESS                  : 'project-access',
    PROJECT_ICON                    : 'project-icon',
    PROJECT_HEALTH                  : 'project-health',
    PROJECT_PARENT                  : 'project-parent',
    PROJECT_TYPE                    : 'project-type',
    PROJECT_PRIORITY                : 'project-priority',
    PROJECT_ESTIMATE                : 'project-estimate',
    PROJECT_PROGRESS                : 'project-progress',

    // PROJECT_DROPDOWN                : 'project-dropdown',
    // PROJECT_FULL_PATH               : 'project-full-path',

    // CRM
    CRM_ACCOUNT                     : 'crm-account',
    CRM_CONTACT                     : 'crm-contact',
    CRM_CONTACTS                    : 'crm-contacts',
    CRM_CONTACT_TYPE                : 'crm-contact-type',
    CRM_CONTACTS_TOTAL              : 'crm-contacts-total',

    // AUTOMATION
    AUTOMATION_TRIGGER_TYPE         : 'automation-trigger-type',
    AUTOMATION_CONDITION_TYPE       : 'automation-condition-type',
    AUTOMATION_ACTION_TYPE          : 'automation-action-type',
    AUTOMATION_STATUS_MULTISELECT   : 'automation-status-multiselect',
    AUTOMATION_STATUS_DROPDOWN      : 'automation-status-dropdown',
    AUTOMATION_USER_MULTISELECT     : 'automation-user-multiselect',
    AUTOMATION_USER_DROPDOWN        : 'automation-user-dropdown',
    AUTOMATION_MESSAGE              : 'automation-message',
    AUTOMATION_PRIORITY_MULTISELECT : 'automation-priority-multiselect',
    AUTOMATION_PRIORITY_DROPDOWN    : 'automation-priority-dropdown',

    // EVENT
    EVENT_START_END                 : 'event-start-end',
    EVENT_PARENT                    : 'event-parent',
    EVENT_STATUS                    : 'event-status',
    EVENT_ASSIGNED_USER             : 'event-assigned-user',
    EVENT_TYPE                      : 'event-type',

    // DOCUMENTS
    DOCUMENT_TYPE                   : 'document-type',
    DOCUMENT_ACCESS_READ            : 'document-access-read',
    DOCUMENT_ACCESS_WRITE           : 'document-access-write',

    // TO-DO LIST TEMPLATE
    TODO_LIST_TEMPLATE              : 'todo-list-template',

    // SYSTEM LOG
    SYSTEM_LOG_STATUS               : 'system-log-status'
}
